module.exports = __webpack_public_path__ + "img/IMG_9543_L_Foamcore.242d4050.jpg";